var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconQuestion01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BBB",
  fillRule: "evenodd",
  d: "M8 1.866a6.133 6.133 0 1 0 0 12.267A6.133 6.133 0 0 0 8 1.866M.8 8a7.2 7.2 0 1 1 14.4 0A7.2 7.2 0 0 1 .8 8",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BBB",
  fillRule: "evenodd",
  d: "M8.338 4.557a1.65 1.65 0 0 0-1.833 1.077l-.177.504-1.007-.354.177-.504a2.715 2.715 0 0 1 5.277.905c0 1.214-.709 1.911-1.364 2.278-.298.166-.591.27-.818.334v1.557H7.526V7.892l.47-.055.01-.001.052-.01a2.742 2.742 0 0 0 .832-.295c.435-.242.818-.636.818-1.346v-.001a1.65 1.65 0 0 0-1.37-1.627M7.455 12c0-.368.299-.667.667-.667h.007a.667.667 0 0 1 0 1.333h-.007A.667.667 0 0 1 7.455 12",
  clipRule: "evenodd"
})));
export default SvgIconQuestion01;